import { render, staticRenderFns } from "./vPreviewLabel.vue?vue&type=template&id=1d210e8a&scoped=true"
import script from "./vPreviewLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./vPreviewLabel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d210e8a",
  null
  
)

export default component.exports